import { isHydrating } from './useDeviceType';

export const isMobileClient = () => {
  if (typeof window === 'undefined') {
    // During SSR, use the device type detected from User-Agent
    return globalThis.__SSR_DEVICE_TYPE__ === 'mobile';
  }

  // During client hydration (before any useEffect has fired), use the SSR device type
  // to match the server-rendered HTML and avoid hydration mismatches
  if (isHydrating() && (window as any).__SSR_DEVICE_TYPE__) {
    return (window as any).__SSR_DEVICE_TYPE__ === 'mobile';
  }

  return window.innerWidth < 768;
};
